import React, {ReactNode} from "react";
import {Tooltip} from "flowbite-react";
import {TooltipProps} from "flowbite-react/dist/types/components/Tooltip/Tooltip";


type OptionalTooltipProps = TooltipProps & {
  showTooltip: boolean;
  children: ReactNode;
}

export function OptionalTooltip({showTooltip, content, children, ...props}: OptionalTooltipProps) {
  return (showTooltip ? <Tooltip
      content={content}
      {...props}
  >
    {children}
  </Tooltip> : <>{children}</>);
}
